import { environment } from 'environments/environment';
import { modules } from './modules';
import { Config } from '@core/config';

export const MwAppConfig: Config = {
  colorTheme: 'theme-default',
  languages: ['en', 'no'],
  defaultLanguage: 'en',
  themeOptions: false,
  modules,
  resetLayoutOnRoutingEnd: true,
  layout: {
    fullWidth: true,
    toolbar: {
      show: true,
      showNewsButton: false, //Task: DNA-3913
    },
    navbar: {
      show: true,
      folded: false,
      foldedWidth: 48,
    },
  },
  environment: {
    ...environment,
    skipAuthRoutes: environment.skipAuthRoutes as [],
    skipCompanyProtectionRoutes: environment.skipCompanyProtectionRoutes as [],
  },
};
